import React from 'react'
import { useModalDisableScroll } from 'helpers/hooks'
import './TeamModal.css'

export default function TeamModal({ children, shown, close }) {
    useModalDisableScroll(shown)

    return shown ? (
        <div
            className="teammodal-backdrop"
            onClick={() => {
                close()
            }}
        >
            <div
                className="teammodal-content"
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <div className="teammodal__text">
                    <h1>the team</h1>
                    <ul className="teammodal__list">
                        <li>
                            <h2>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://twitter.com/MindOfGrowth"
                                >
                                    @Mindofgrowth
                                </a>
                            </h2>
                            <br />- creative content & social media, engagement{' '}
                        </li>
                        <li>
                            <h2>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://twitter.com/PippiWestwood"
                                >
                                    @PippiWestwood
                                </a>
                            </h2>
                            <br />- creative content & social media, engagement{' '}
                        </li>
                        <li>
                            <h2>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://twitter.com/itsthatguykyle"
                                >
                                    @itsthatguykyle
                                </a>
                            </h2>
                            <br />- lead artist{' '}
                        </li>
                        <li>
                            <h2>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://twitter.com/ab0lomination"
                                >
                                    @ab0lomination
                                </a>
                            </h2>
                            <br />- smart contract dev.{' '}
                        </li>
                        <li>
                            <h2>
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://twitter.com/GoldenXnft"
                                >
                                    @GoldenXNFT
                                </a>
                            </h2>
                            <br />- company led by Kirk - runs a lot of NFT
                            projects{' '}
                        </li>
                    </ul>
                    <button
                        onClick={() => {
                            close()
                        }}
                        className="okButton"
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    ) : null
}
